import React from 'react'
import { Envio } from '@newspacebpo/mf_protocolo_bfveic'
const EnvioPage = (props) => {
    return (
            <Envio {...props}/>
    );
};

export { EnvioPage };